import "./digital-assets-storefront-pdp-bar.scss";

export class DigitalAssetsStorefrontPdpBar {
  #wrapperSelector = "";

  constructor(props) {
    this.#wrapperSelector = props.wrapper;
  }

  get #$wrapper() {
    return document.querySelector(this.#wrapperSelector);
  }

  toggleActiveClass() {
    this.#$wrapper.classList.toggle("active-bar");
  }
}

export default () =>
  new DigitalAssetsStorefrontPdpBar({
    wrapper: ".js-digital-assets-storefront-pdp-bar"
  });
